import { render, staticRenderFns } from "./RevokeDevice.vue?vue&type=template&id=4882564f&scoped=true"
import script from "./RevokeDevice.vue?vue&type=script&lang=js"
export * from "./RevokeDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882564f",
  null
  
)

export default component.exports